import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';

export const Container = styled.div`
  width: 100%;
`;

export const Columns = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-columns: repeat(${(p) => p.$columns}, minmax(0, 1fr));
  gap: ${space['space-800']};
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Header = styled.div`
  margin-bottom: ${space['space-400']};
`;

export const StaticHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
  padding: ${layout.inputPadding};
  border: 1px solid ${semantic.border.default};
  border-radius: ${size.radius['radius-sm']};
  background: ${semantic.bg.canvas};
`;

export const HeaderLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  line-height: ${primitives.typography.lineHeight.tight};
`;

export const HeaderName = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const TriggerValue = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
  white-space: normal;
  text-align: left;
`;

export const DateGroup = styled.div`
  display: grid;
  grid-template-columns: ${space['space-2400']} 1fr;
  gap: ${space['space-400']};
  padding-top: ${space['space-400']};

  &[data-single='true'] {
    display: block;
  }
`;

export const DateLabel = styled.h4`
  margin: 0;
  padding-top: ${space['space-300']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  white-space: nowrap;

  [data-single='true'] > & {
    padding-top: 0;
    margin-bottom: ${space['space-200']};
  }
`;

export const Activities = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const ActivityRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-400']};
  padding: ${space['space-300']} 0;
  border-bottom: 1px solid ${semantic.border.subtle};
`;

export const ActivityText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
  min-width: 0;
`;

export const ActivityTitle = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const ActivityLocation = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  line-height: ${primitives.typography.lineHeight.normal};
`;
